import Vue from "vue";
import Vuex from "vuex";
import { firestoreAction, vuexfireMutations } from "vuexfire";
import app from 'firebase/app'
const firebaseConfig = {
    apiKey: "AIzaSyDJEmqoV5htpJTzLv-0tznxigrzQXiDE9I",
    authDomain: "vexpo-92b48.firebaseapp.com",
    projectId: "vexpo-92b48",
    storageBucket: "vexpo-92b48.appspot.com",
    messagingSenderId: "293938355125",
    appId: "1:293938355125:web:9480c489f7d05c4df917fc",
    measurementId: "G-RVPQEJ8D8M"
};

// Initialize Firebase
app.initializeApp(firebaseConfig);
import 'firebase/firestore'
export const firebase = app
export const db = app.firestore()


Vue.use(Vuex);

const serializeObj = (doc) => {
    if (!doc)
        return doc;
    const data = doc.data();
    return {
        ...data,
        objectId: data.objectId || data.id,
        id: doc.id,
    }
}

const serializeManufacturer = (doc) => {
    if (!doc)
      return doc;
    return {
        id: doc.id,
        ...doc.data()
    }
}

export default new Vuex.Store({
    state: {
        user: null,
        userProfile: null,
        expoManufacturers: [],
        supportMessages: [],
        expoObjects: [],
        expoEvents: [],
        expoRewards: [],
    },
    getters: {
        expoObjectById: (state) => (id) => {
            return state.expoObjects.find(thing => thing.id === id);
        },
        expoManufacturerById: (state) => (id) => {
            return state.expoManufacturers.find(thing => thing.id === id);
        },
    },
    mutations: {
        user(state, user) {
            state.user = user;
        },
        ...vuexfireMutations
    },
    actions: {
        // Visitors are temporary anonymous users - nothing is stored anywhere,
        // so actions that used to write to Firestore / cloud functions are no-ops
        likeObject() { return Promise.resolve() },
        collectStar() { return Promise.resolve() },
        sendSupportMessage() { return Promise.resolve() },
        updateUserProfile() { return Promise.resolve() },
        unbindAll: firestoreAction( ({ unbindFirestoreRef }) => {
            unbindFirestoreRef('expoObjects')
            unbindFirestoreRef('expoEvents')
            unbindFirestoreRef('expoRewards')
            unbindFirestoreRef('expoManufacturers')
        }),
        bindExpoObjects: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
              'expoObjects',
              db.collection('objects').orderBy('name'),
              {
                  serialize: serializeObj
              }
            )
        }),
        unbindExpoObjects: firestoreAction(({ unbindFirestoreRef }) => {
            unbindFirestoreRef('expoObjects')
        }),
        bindExpoEvents: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
              'expoEvents',
              db.collection('events').orderBy('name')
            )
        }),
        unbindExpoEvents: firestoreAction(({ unbindFirestoreRef }) => {
            unbindFirestoreRef('expoEvents')
        }),
        bindExpoRewards: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
              'expoRewards',
              db.collection('rewards').orderBy('name')
            )
        }),
        unbindExpoRewards: firestoreAction(({ unbindFirestoreRef }) => {
            unbindFirestoreRef('expoRewards')
        }),
        bindExpoManufacturers: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef(
              'expoManufacturers',
              db.collection('manufacturers').orderBy('name'),
              {
                  serialize: serializeManufacturer
              }
            )
        }),
        unbindExpoManufacturers: firestoreAction(({ unbindFirestoreRef }) => {
            unbindFirestoreRef('expoManufacturers')
        }),
    }
});
